module.exports = __webpack_public_path__ + "static/DeadlineAssistant-f6c25e745464de82ec2411d79a1420e7.svg";